import reqQuote from '@/views/reqQuote/local/en'
import components from '@/components/local/en'
export default {
  route: {
    dashboard: 'Dashboard',
    introduction: 'Introduction',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    componentIndex: 'Introduction',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: 'Mixin',
    backToTop: 'BackToTop',
    dragDialog: 'Drag Dialog',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    nested: 'Nested Routes',
    menu1: 'Menu 1',
    'menu1-1': 'Menu 1-1',
    'menu1-2': 'Menu 1-2',
    'menu1-2-1': 'Menu 1-2-1',
    'menu1-2-2': 'Menu 1-2-2',
    'menu1-3': 'Menu 1-3',
    menu2: 'Menu 2',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    treeTable: 'Tree Table',
    customTreeTable: 'Custom TreeTable',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    example1: 'example 1',
    systemAnalysis: 'System analysis',
    customerInformation: 'Customer information',
    quotationInquiry: 'Quotation Inquiry',
    createANew: 'Create a new RFQ',
    modifyTheQuote: 'Modify the RFQ',
    historicalData: 'Historical data',
    createANewPittedPaper: 'New RFQ(pitted paper)',
    quotation: 'Quotation',
    productSettings: 'Product settings',
    quotedProcessParameters: 'Quoted process parameters',
    cableSetting: 'Cable setting',
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    screenfull: 'screenfull',
    theme: 'theme'
  },
  login: {
    title: 'Wangying Group Quotation System',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !',
    selectCompany: 'Please select a company',
    enterUserName: 'Please enter a user name',
    enterPassword: 'Please enter your password',
    remember_the_password: 'Remember the password',
    userNameHint: 'Username consists of 5-20 letters or numbers',
    passwordHint: 'Password cannot be less than 5 digits'
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    roles: 'Your roles',
    switchRoles: 'Switch roles'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text editor is a core part of management system, but at the same time is a place with lots of problems. In the process of selecting rich texts, I also walked a lot of detours. The common rich text editors in the market are basically used, and the finally chose Tinymce. See documentation for more detailed rich text editor comparisons and introductions.',
    dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Imp',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    Copy: 'Copy',
    Hint: 'Hint',
    Delete_this_data: 'Delete this data',
    Delete_success: 'Delete success',
    Delete_fail: 'Delete fail',
    The_deletion_was_canceled: 'The deletion was canceled',
    Modify: 'Modify',
    View: 'View',
    Upload: 'Upload',
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export selected items',
    placeholder: 'Please enter the file name(default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name(default file)'
  },
  theme: {
    change: 'Theme change',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  quoteCommon: {
    search: 'Search',
    new: 'New',
    pleaseEnter: 'Please enter ',
    Input_format: 'Input format',
    Application_form_number: 'Application form number',
    Estimate_No: 'Estimate No',
    Customer_number: 'Customer number',
    Customer_name: 'Customer name',
    Product_number: 'Product number',
    Product_size: 'Product size',
    Product_name: 'Product name',
    Number_of_products: 'Number of products',
    Please_select: 'Please select',
    Whole: 'Whole',
    Not_approved: 'Not approved',
    Approved: 'Approved',
    Replied: 'Replied',
    No_reply: 'No reply',
    Status: 'Status',
    typeOfGoods: 'Type Of Goods',
    Please_enter_a_keyword: 'Please enter a keyword',
    Please_enter_customer_information_first: 'Please enter customer information first',
    The_user_has_no_permission_to_view_the_quotation_information_of_this_customer: 'The user has no permission to view the quotation information of this customer',
    Details: 'Details',
    Remark: 'Remark',
    Quotation: 'Quotation',
    More: 'More',
    Submit: 'Submit',
    Number: 'Number',
    Name: 'Name',
    Choose: 'Choose',
  },
  analyze: {
    title: 'Department/Day/Billing Quantity',
    pitCarton: 'Pit carton',
    bookEdition: 'Book edition',
    colorBox: 'Color box ',
    boutiqueBox: 'Boutique box',
    woodenBox: 'Wooden box',
  },
  quoteQuery: {
    no: 'No',
    pleaseEnter: 'Please enter',
    startDate: 'Start date',
    endDate: 'End date',
    myOrder: 'My order',
    moreConditions: 'More conditions',
    newPitCarton: 'New pit carton',
    businessDepartment: 'Business department',
    creationTime: 'Creation time',
    Created_by: 'Created by',
    Quotation_clerk: 'Quotation clerk',
    Application_status: 'Application status',
    Valuation_status: 'Valuation status',
    Ergonomic_information: 'Ergonomic information',
    Inquiry_information: 'Inquiry information',
  },
  reqQuote,
  components
}



// WEBPACK FOOTER //
// ./src/lang/en.js